import { ChangeDetectorRef, Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { SwitchService } from '../../services/switch.service';
import { PopularDestinationCategoryService } from './popular-destination-category.service';
// import { DataTablesSettings } from 'angular-datatables';

@Component({
  selector: 'app-popular-destinations-category',
  standalone: false,
  templateUrl: './popular-destinations-category.component.html',
  styleUrl: './popular-destinations-category.component.css'
})
export class PopularDestinationsCategoryComponent {

  dtOptions: any = {};
  
  currentPage = 1;
  pageSize = 5;

  isModalOpen = false;
  successMessage = '';
  errorMessage = '';

  popularDestinationCategoryId = 0;
  parentCategoryId: number | null = null;
  isEnabled: boolean = true;

  languageId = 0;
  nameKh = '';
  nameEn = '';


  popularDestinationCategories: any[] = [];
  mergedCategories: any[] = [];

  isEnableSave: boolean = false;
  isEnableUpdate: boolean = false;
  isEnableDelete: boolean = false;

  filteredPopularDestinationCategories: any[] = [];
  languages: any[] = [];
  activeTab: string = 'all';
  activeTabPopup: number = 1;
  searchText = '';

  constructor(
    private popularDestinationCategoriesService: PopularDestinationCategoryService,
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef,
    private swService: SwitchService
  ) { }


  ngOnInit() {
    this.loadPopularDestinationCategories();
    this.loadLanguages();
  }

  get pagedCategories() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.filteredPopularDestinationCategories.slice(start, end);
  }

  totalPages() {
    return Math.ceil(this.filteredPopularDestinationCategories.length / this.pageSize);
  }

  changePage(page: number) {
    this.currentPage = page;
  }

  loadPopularDestinationCategories() {

    this.popularDestinationCategoriesService.getAllPopularDestinationCategories().subscribe((res: any) => {
      this.popularDestinationCategories = res.data || [];
      this.filteredPopularDestinationCategories = res.data || [];
      this.mergeCategories();
      this.filterPopularDestinationCategories('kh');
    });
  }

  mergeCategories() {
    const grouped: { [key: number]: any } = {};

    this.popularDestinationCategories.forEach(category => {
      if (!grouped[category.popularDestinationCategoryId]) {
        grouped[category.popularDestinationCategoryId] = {
          categoryId: category.popularDestinationCategoryId,
          parentCategoryId: category.parentCategoryId ?? null,
          kh: '',
          en: '',
          parentKh: '',
          parentEn: '',
          isEnabled: category.isEnabled
        };
      }

      if (category.languageCode === 'kh') {
        grouped[category.popularDestinationCategoryId].kh = category.name;
        grouped[category.popularDestinationCategoryId].parentKh = category.parentName ?? '';
      }

      if (category.languageCode === 'en') {
        grouped[category.popularDestinationCategoryId].en = category.name;
        grouped[category.popularDestinationCategoryId].parentEn = category.parentName ?? '';
      }
    });

    this.mergedCategories = Object.values(grouped);
  }

  filterPopularDestinationCategories(tab: string) {
    const keyword = this.searchText.trim().toLowerCase();
    this.currentPage = 1;

    this.filteredPopularDestinationCategories = this.popularDestinationCategories.filter(category => {
      const matchesTab = category.languageCode === tab;
      const matchesSearch = !keyword ||
        `${category.name ?? ''} ${category.parentName ?? ''} ${category.languageCode ?? ''}`
          .toLowerCase()
          .includes(keyword);

      return matchesTab && matchesSearch;
    });
  }

  loadLanguages() {
    this.languageService.getAll().subscribe((res: any) => {
      this.languages = res.data;
      this.languages = res.data.sort((a: { languageId: number; }, b: { languageId: number; }) => a.languageId - b.languageId);
      if (this.languages.length > 0) {
        this.setTab(this.languages[0].code);
      }
    });
  }

  setTab(tab: string) {

    this.activeTab = tab;
    this.filterPopularDestinationCategories(tab);

  }

  setTabPopup(tab: number) {
    this.activeTabPopup = tab;
  }

  getLanguageCount(lang: string): number {
    return this.popularDestinationCategories.filter(r => r.languageCode === lang).length;
  }

  getParentCategoryOptions() {
    return this.mergedCategories.filter(category =>
      category.categoryId !== this.popularDestinationCategoryId
    );
  }

  getCategoryLabel(category: any): string {
    const categoryName = [category.kh, category.en].filter(Boolean).join(' - ');
    const parentName = [category.parentKh, category.parentEn].filter(Boolean).join(' - ');

    return parentName ? `${parentName} / ${categoryName}` : categoryName;
  }


  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }


  switchEnable() {
    this.swService.switchEnable(this.isEnabled);
  }


  visibleButtonControl(eventName: string) {

    this.isEnableSave = false;
    this.isEnableUpdate = false;
    this.isEnableDelete = false;

    if (eventName === 'Add') { this.isEnableSave = true }
    else if (eventName === 'Edit') { this.isEnableUpdate = true }
    else if (eventName === 'Delete') { this.isEnableDelete = true }

  }


  viewData(id: number, eventName: string) {

    this.visibleButtonControl(eventName);
    this.popularDestinationCategoryId = id;

    this.popularDestinationCategoriesService.getPopularDestinationCategoryById(id).subscribe({
      next: (res) => {

        if (res.status === "success") {
          const data = res.data || [];
          const first = data[0];

          this.nameKh = '';
          this.nameEn = '';
          this.parentCategoryId = first?.parentCategoryId ?? null;
          this.isEnabled = first?.isEnabled ?? true;

          data.forEach((item: any) => {
            if (item.languageCode === 'kh') {
              this.nameKh = item.name;
            } else if (item.languageCode === 'en') {
              this.nameEn = item.name;
            }
          });

          this.openModal();
        } else {
          this.errorMessage = res.message;
        }

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      },
      error: (err) => {

        this.errorMessage = "Failed to create language";

        setTimeout(() => {
          this.clearMsg();
          this.cdr.detectChanges();
        }, 3000);

      }
    });

  }

  clearMsg() {
    this.successMessage = '';
    this.errorMessage = '';
  }

  addNew() {
    this.visibleButtonControl('Add');
    this.resetForm();
    this.openModal();
    
  }

  refreshData(status: string, message: string) {

    if (status === "success") {
      this.successMessage = message;
      this.closeModal();
      this.loadPopularDestinationCategories();
      this.resetForm();
    } else {
      this.errorMessage = message;
    }

    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);

  }

  exceptionData(message: string) {
    this.errorMessage = message;
    setTimeout(() => {
      this.clearMsg();
      this.cdr.detectChanges();
    }, 3000);
  }

  save() {

    const request = {
      "popularDestinationCategoryId": 0,
      "parentCategoryId": this.parentCategoryId,
      "isEnabled": this.isEnabled,
      "translations": [
        {
          "languageId": 1,
          "name": this.nameKh
        },
        {
          "languageId": 2,
          "name": this.nameEn
        }
      ]
    }

    this.clearMsg();

    this.popularDestinationCategoriesService.create(request).subscribe({
      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

  update() {

    this.clearMsg();

    const request = {
      "popularDestinationCategoryId": this.popularDestinationCategoryId,
      "parentCategoryId": this.parentCategoryId,
      "isEnabled": this.isEnabled,
      "translations": [
        {
          "languageId": 1,
          "name": this.nameKh
        },
        {
          "languageId": 2,
          "name": this.nameEn
        }
      ]
    }

    this.popularDestinationCategoriesService.update(request).subscribe({

      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }

    });

  }

  delete() {

    if (!confirm("Are you sure you want to delete ?")) {
      return;
    }

    this.popularDestinationCategoriesService.delete(this.popularDestinationCategoryId).subscribe({
      next: (res) => {
        this.refreshData(res.status, res.message);
      },
      error: (err) => {
        this.exceptionData(err);
      }
    });

  }

  resetForm() {
    this.popularDestinationCategoryId = 0;
    this.parentCategoryId = null;
    this.nameKh = '';
    this.nameEn = '';
    this.isEnabled = false;
  }

}
